import React, { useState } from "react";
import ContentBox from "../ContentBox/ContentBox";
import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import ButtonLoading from "../Button/ButtonLoading";
import ApiClient from "../../services/ApiClient";
import { Roles } from "../../types/BackofficeUser";
import releaseUpdateStyles from "./releaseUpdatesStyles";
import LegalbirdTipTapEditorProvider from "../LbEditor/LegalbirdTipTapEditorProvider";
import LegalbirdTipTapEditor from "../LbEditor/LegalbirdTipTapEditor";
import { useCurrentEditor } from "@tiptap/react";
import { getEditorHtml } from "../../services/Editor/editorFunctions";

export default function CreateReleaseUpdate() {
  return (
    <LegalbirdTipTapEditorProvider>
      <CreateReleaseUpdateInner />
    </LegalbirdTipTapEditorProvider>
  );
}

function CreateReleaseUpdateInner() {
  const [isInternalReleaseUpdate, setIsInternalReleaseUpdate] = useState(true);
  const [isExternalReleaseUpdate, setIsExternalReleaseUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  const onSubmit = async () => {
    setIsLoading(true);

    let visibleToRoles = [Roles.admin, Roles.developer];

    if (isInternalReleaseUpdate) {
      visibleToRoles.push(Roles.accounting, Roles.accountmanager, Roles.traineeLawyer, Roles.lawyer);
    }
    if (isExternalReleaseUpdate) {
      visibleToRoles.push(Roles.external);
    }

    await ApiClient.post("/release_updates", {
      body: JSON.stringify({
        visibleToRoles: visibleToRoles,
        content: getEditorHtml(editor),
      }),
    });
    editor.commands.clearContent();
    setIsExternalReleaseUpdate(false);
    setIsInternalReleaseUpdate(true);
    setIsLoading(false);
  };

  return (
    <ContentBox>
      <Grid
        container
        spacing={2}
        sx={{
          justifyContent: "center",
          alignItems: "center"
        }}>
        <Grid size={12}>
          <LegalbirdTipTapEditor />
        </Grid>
        <Grid size={12}>
          <Typography variant={"h4"} sx={{ textAlign: "center" }}>
            Sichtbarkeit
          </Typography>
        </Grid>
        <Grid>
          <FormControlLabel
            labelPlacement="start"
            control={
              <Checkbox
                checked={isInternalReleaseUpdate}
                onChange={({ target }) => setIsInternalReleaseUpdate(target.checked)}
              />
            }
            label={"Intern"}
          />
        </Grid>
        <Grid>
          <FormControlLabel
            labelPlacement="start"
            control={
              <Checkbox
                checked={isExternalReleaseUpdate}
                onChange={({ target }) => setIsExternalReleaseUpdate(target.checked)}
              />
            }
            label={"Extern"}
          />
        </Grid>
        <Grid size={12} />
        <Grid>
          <ButtonLoading
            isLoading={isLoading}
            fullWidth={false}
            variant={"contained"}
            disabled={(!isExternalReleaseUpdate && !isInternalReleaseUpdate) || editor.isEmpty}
            onClick={onSubmit}
            sx={releaseUpdateStyles.button}
          >
            Releaseupdate veröffentlichen
          </ButtonLoading>
        </Grid>
      </Grid>
    </ContentBox>
  );
}
